/* Flappie Partner Finder v3. Reads the ACTIVE installation_partner metaobjects
   that the Liquid section embeds as JSON, resolves the customer's PLZ from the
   shipped GeoNames tables, sorts by distance, filters by country, service and
   certification. Scoped per section instance. Vanilla JS, no dependencies. */
(function () {
  "use strict";

  var SERVICE_LABELS = {
    montage: "Montage", glass_complete: "Glas-Komplettlösung",
    single_glazing: "Einfachglas", double_glazing: "Doppelglas",
    triple_glazing: "Dreifachglas", wooden_door: "Holztür",
    rental_ok: "Auch zur Miete", special_case: "Spezialfall"
  };
  var REACH_LABELS = { local: "lokal", regional: "reist weiter", national: "landesweit" };
  var FLAGS = { CH: "🇨🇭", DE: "🇩🇪", AT: "🇦🇹", FR: "🇫🇷", IT: "🇮🇹", NL: "🇳🇱", GB: "🇬🇧", BE: "🇧🇪", ES: "🇪🇸", PT: "🇵🇹", PL: "🇵🇱", SE: "🇸🇪", DK: "🇩🇰", FI: "🇫🇮", NO: "🇳🇴", IE: "🇮🇪", CZ: "🇨🇿", HU: "🇭🇺", GR: "🇬🇷", RO: "🇷🇴", SK: "🇸🇰", SI: "🇸🇮", HR: "🇭🇷", LU: "🇱🇺", BG: "🇧🇬", EE: "🇪🇪", LV: "🇱🇻", LT: "🇱🇹", CY: "🇨🇾", MT: "🇲🇹" };
  var COUNTRY_NAMES = { CH: "Schweiz", DE: "Deutschland", AT: "Österreich", FR: "Frankreich", IT: "Italien", NL: "Niederlande", GB: "Vereinigtes Königreich", BE: "Belgien", ES: "Spanien", PT: "Portugal", PL: "Polen", SE: "Schweden", DK: "Dänemark", FI: "Finnland", NO: "Norwegen", IE: "Irland", CZ: "Tschechien", HU: "Ungarn", GR: "Griechenland", RO: "Rumänien", SK: "Slowakei", SI: "Slowenien", HR: "Kroatien", LU: "Luxemburg", BG: "Bulgarien", EE: "Estland", LV: "Lettland", LT: "Litauen", CY: "Zypern", MT: "Malta" };
  /* "in der Schweiz", "in den Niederlanden" ... everything else: "in <Name>" */
  var IN_COUNTRY = { CH: "der Schweiz", NL: "den Niederlanden", GB: "dem Vereinigten Königreich", SK: "der Slowakei", CZ: "Tschechien" };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function haversineKm(aLat, aLon, bLat, bLon) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (bLat - aLat) * toRad, dLon = (bLon - aLon) * toRad;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(aLat * toRad) * Math.cos(bLat * toRad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }

  function num(v) {
    var n = parseFloat(v);
    return isFinite(n) ? n : null;
  }

  function list(v) {
    if (Array.isArray(v)) return v.filter(Boolean);
    if (typeof v === "string" && v) {
      try { var parsed = JSON.parse(v); if (Array.isArray(parsed)) return parsed.filter(Boolean); } catch (e) { /* fall through */ }
      return v.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    }
    return [];
  }

  function truthy(v) { return v === true || v === "true"; }

  /* One bad entry never hides the others: normalise each row on its own and
     drop only rows that cannot be shown at all (no name or no country). */
  function normalise(raw) {
    if (!raw || typeof raw !== "object" || !raw.name) return null;
    var country = String(raw.country || "").trim().toUpperCase();
    if (!/^[A-Z]{2}$/.test(country)) return null;
    var served = list(raw.countries_served).map(function (c) { return String(c).trim().toUpperCase(); });
    if (!served.length) served = [country];
    return {
      id: raw.id || raw.name,
      name: String(raw.name),
      city: raw.city || "",
      country: country,
      plz: raw.plz ? String(raw.plz).trim() : "",
      lat: num(raw.lat),
      lon: num(raw.lon),
      countries_served: served,
      services: list(raw.services),
      reach: raw.reach || "",
      email: raw.email || "",
      phone: raw.phone || "",
      website: raw.website || "",
      inquiry_url: raw.inquiry_url || "",
      certified: truthy(raw.certified),
      recommended: truthy(raw.recommended),
      priority: num(raw.priority) || 0,
      logo: raw.logo || ""
    };
  }

  function readPartners(section) {
    var node = section.querySelector("script[data-flappie-partners]");
    var rows;
    try { rows = node ? JSON.parse(node.textContent || "[]") : []; } catch (e) { rows = []; }
    if (!Array.isArray(rows)) return [];
    return rows.map(normalise).filter(Boolean);
  }

  function init(wrap) {
    var section = wrap.closest(".fl-finder") || wrap;
    var plzBase = wrap.getAttribute("data-plz-base") || "";
    var limit = parseInt(wrap.getAttribute("data-limit"), 10) || 9;
    var certifiedBonus = parseFloat(wrap.getAttribute("data-verified-bonus")) || 0;

    var countrySel = wrap.querySelector(".fl-country");
    var plzInput = wrap.querySelector(".fl-plz");
    var goBtn = wrap.querySelector(".fl-go");
    var svcChips = Array.prototype.slice.call(wrap.querySelectorAll(".fl-chip[data-svc]"));
    var certChip = wrap.querySelector(".fl-chip[data-cert]");
    var summary = wrap.querySelector(".fl-summary");
    var results = wrap.querySelector(".fl-results");
    var empty = wrap.querySelector(".fl-empty");

    var partners = readPartners(section);
    var state = { service: "all", certOnly: false, origin: null, plz: "" };
    var tableCache = {};

    function loadTable(cc) {
      if (tableCache[cc]) return tableCache[cc];
      tableCache[cc] = fetch(plzBase + "plz-" + cc.toLowerCase() + ".json")
        .then(function (r) { return r.ok ? r.json() : {}; })
        .catch(function () { return {}; });
      return tableCache[cc];
    }

    function lookup(t, cc, plz) {
      var k = String(plz).trim().toUpperCase().replace(/\s+/g, "");
      var v = t[k];
      if (!v && cc === "NL") v = t[k.slice(0, 4)];                      // NL: PC4
      if (!v && cc === "GB") v = t[k.slice(0, -3)] || t[k.split(" ")[0]]; // GB: outward code
      return v ? { lat: v[0], lon: v[1] } : null;
    }

    function geocode(cc, plz) {
      return loadTable(cc).then(function (t) { return lookup(t, cc, plz); });
    }

    /* Entries added by hand in Shopify may have only a PLZ. Resolve their
       coordinates from the same table the customer search uses. Only runs
       when a customer actually searches, so the page load stays light. */
    function ensureCoords(country) {
      var missing = partners.filter(function (p) {
        return (p.lat == null || p.lon == null) && p.plz && p.countries_served.indexOf(country) !== -1;
      });
      return Promise.all(missing.map(function (p) {
        return geocode(p.country, p.plz).then(function (geo) {
          if (geo) { p.lat = geo.lat; p.lon = geo.lon; }
        });
      }));
    }

    function populateCountries() {
      var set = {};
      partners.forEach(function (p) {
        p.countries_served.forEach(function (c) { set[c] = 1; });
      });
      var codes = Object.keys(set).sort(function (a, b) {
        return (COUNTRY_NAMES[a] || a).localeCompare(COUNTRY_NAMES[b] || b);
      });
      countrySel.innerHTML = codes.map(function (c) {
        return '<option value="' + c + '">' + (FLAGS[c] || "") + " " + esc(COUNTRY_NAMES[c] || c) + "</option>";
      }).join("");
      if (set.CH) countrySel.value = "CH";
    }

    function cardHtml(p) {
      var flag = FLAGS[p.country] || "";
      var dist = (typeof p._dist === "number")
        ? '<span class="fl-dist">' + (p._dist < 1 ? "<1" : Math.round(p._dist)) + " km entfernt</span>"
        : "";
      var reach = p.reach && REACH_LABELS[p.reach] ? esc(REACH_LABELS[p.reach]) : "";
      var badges = "";
      if (p.recommended) badges += '<span class="fl-badge is-reco">Empfohlen</span>';
      if (p.certified) badges += '<span class="fl-badge" data-flappie-badge="flappie-certified">Flappie-zertifiziert</span>';

      // Highlight whatever the customer selected, so the card shows why it matched.
      var svcs = p.services.map(function (k) {
        var hot = state.service === "all" || k === state.service;
        return '<span class="' + (hot ? "fl-svc is-primary" : "fl-svc") + '">' +
               esc(SERVICE_LABELS[k] || k) + "</span>";
      }).join("");

      var logo = p.logo
        ? '<img src="' + esc(p.logo) + '" alt="' + esc(p.name) + ' Logo" width="52" height="52" loading="lazy" ' +
          'onerror="this.style.display=\'none\'">'
        : "🔧";

      var href = p.inquiry_url ? esc(p.inquiry_url)
               : (p.email ? "mailto:" + esc(p.email) : (p.website ? esc(p.website) : "#"));
      var companyName = p.website
        ? '<a class="fl-card-name" href="' + esc(p.website) + '" target="_blank" rel="noopener">' + esc(p.name) + "</a>"
        : '<div class="fl-card-name">' + esc(p.name) + "</div>";
      var meta = flag + " " + esc(p.city || "");
      if (reach) meta += " · " + reach;

      return '' +
        '<article class="fl-card' + (p.recommended ? " is-reco" : "") + '" data-partner="' + esc(p.id) + '">' +
          '<div class="fl-card-top">' +
            '<div class="fl-logo">' + logo + "</div>" +
            '<div class="fl-card-id">' +
              companyName +
              '<div class="fl-card-meta">' + meta + "</div>" +
            "</div>" +
            dist +
          "</div>" +
          (badges ? '<div class="fl-badges">' + badges + "</div>" : "") +
          '<div class="fl-svcs">' + svcs + "</div>" +
          '<a class="fl-cta" href="' + href + '" target="_blank" rel="noopener">Anfragen</a>' +
        "</article>";
    }

    function render() {
      var country = countrySel.value;
      var inCountry = partners.filter(function (p) { return p.countries_served.indexOf(country) !== -1; });

      // "Nur zertifizierte" only appears once a certified partner serves this country.
      var anyCertified = inCountry.some(function (p) { return p.certified; });
      if (certChip) {
        certChip.hidden = !anyCertified;
        if (!anyCertified && state.certOnly) {
          state.certOnly = false;
          certChip.classList.remove("is-active");
          certChip.setAttribute("aria-pressed", "false");
        }
      }

      var rows = inCountry.filter(function (p) {
        if (state.service !== "all" && p.services.indexOf(state.service) === -1) return false;
        if (state.certOnly && !p.certified) return false;
        return true;
      });

      rows.forEach(function (p) {
        p._dist = (state.origin && p.lat != null && p.lon != null)
          ? haversineKm(state.origin.lat, state.origin.lon, p.lat, p.lon) : null;
        // Distance first. Certified ranks as if certifiedBonus km closer; manual priority in km.
        p._score = (p._dist == null ? 1e6 : p._dist) - (p.certified ? certifiedBonus : 0) - p.priority;
      });

      rows.sort(function (a, b) {
        if (b.recommended !== a.recommended) return b.recommended ? 1 : -1; // recommended pinned on top
        if (state.origin) return a._score - b._score;                       // nearest first
        return a.name.localeCompare(b.name);                                // no PLZ: alphabetical
      });

      var total = rows.length;
      rows = rows.slice(0, limit);
      results.innerHTML = rows.map(cardHtml).join("");
      empty.hidden = rows.length > 0;

      var countryLabel = IN_COUNTRY[country] || COUNTRY_NAMES[country] || country;
      var more = total > rows.length ? " (" + rows.length + " von " + total + " angezeigt)" : "";
      if (state.origin && state.plz && rows.length) {
        summary.hidden = false;
        summary.innerHTML = "<strong>" + total + " Partner</strong> in " + esc(countryLabel) +
          ", sortiert nach Entfernung zu " + esc(state.plz) + more + ".";
      } else if (rows.length) {
        summary.hidden = false;
        summary.innerHTML = "<strong>" + total + " Partner</strong> in " + esc(countryLabel) + more +
          ". Gib deine PLZ ein, um nach Nähe zu sortieren.";
      } else {
        summary.hidden = true;
      }
    }

    function search() {
      var plz = (plzInput.value || "").trim();
      var country = countrySel.value;
      state.plz = plz;
      if (!plz) { state.origin = null; render(); return; }
      goBtn.disabled = true;
      Promise.all([geocode(country, plz), ensureCoords(country)]).then(function (res) {
        var geo = res[0];
        goBtn.disabled = false;
        if (!geo) {
          state.origin = null;
          summary.hidden = false;
          summary.innerHTML = "PLZ <strong>" + esc(plz) + "</strong> nicht gefunden. Bitte prüfen.";
          results.innerHTML = ""; empty.hidden = true;
          return;
        }
        state.origin = geo;
        render();
      }).catch(function () { goBtn.disabled = false; });
    }

    goBtn.addEventListener("click", search);
    plzInput.addEventListener("keydown", function (e) { if (e.key === "Enter") search(); });
    countrySel.addEventListener("change", function () { if (state.plz) search(); else render(); });
    svcChips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        state.service = chip.getAttribute("data-svc");
        svcChips.forEach(function (c) { c.classList.toggle("is-active", c === chip); });
        render();
      });
    });
    if (certChip) {
      certChip.addEventListener("click", function () {
        state.certOnly = !state.certOnly;
        certChip.classList.toggle("is-active", state.certOnly);
        certChip.setAttribute("aria-pressed", state.certOnly ? "true" : "false");
        render();
      });
    }

    populateCountries();
    render();
  }

  function boot() {
    document.querySelectorAll(".fl-finder .fl-wrap[data-flappie-finder]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
